<template>
  <div>
    <div v-if="isMiniElement">
      <i :class="`budget-${elBudgets[0].icon || ''}`"></i> {{ elBudgets.length }}
    </div>
    <template v-else>
      <template v-for="(budgets, state) in elBudgetsByStates">
        <span v-for="(budget, icon) in budgets" class="mr-1">
          <span class="nobr">
            <span :class="`budget-${icon || ''}`" class="mr-.5"></span>
            <span v-if="budget.amount_inprogress && budget.amount">{{ $filters.number(budget.amount_inprogress) }}&nbsp;/</span>
            <span v-if="budget.amount_inprogress && ! budget.amount">{{ $filters.number(budget.amount_inprogress) }}</span>
            <span v-if="budget.amount">{{ $filters.number(budget.amount) }}</span>
          </span>
          <span v-if="budgetStates[state]">&nbsp;({{ $filters.lowercase(budgetStates[state]) }})</span>
        </span>
      </template>
    </template>
  </div>
</template>

<script>
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    props: {
      el: { type: Object, required: true },
      isMiniElement: { type: Boolean, default: false },
    },
    computed: {
      elBudgets() {
        return this.el.getBudgets()?.filter(budget => budget.amount || budget.amount_inprogress);
      },
      budgetStates() {
        return useUsersAccessRightStore().config.budgetStates;
      },
      elBudgetsByStates() {
        if (! this.elBudgets) return null;
        const budgetStateKeysSet = new Set(Object.keys(this.budgetStates));
        const budgetsByStates = {};
        this.elBudgets.forEach((budget) => {
          if (! budget.amount && ! budget.amount_inprogress) return;
          const state = budgetStateKeysSet.has(budget.state) ? budget.state : '';
          const icon = budget.icon || '';
          if (! budgetsByStates[state]) budgetsByStates[state] = {};
          if (! budgetsByStates[state][icon]) budgetsByStates[state][icon] = { amount: 0, amount_inprogress: 0 };
          budgetsByStates[state][icon].amount += budget.amount || 0;
          budgetsByStates[state][icon].amount_inprogress += budget.amount_inprogress || 0;
        });
        return budgetsByStates;
      },
    },
  };
</script>
